import React, { Component } from 'react';
import { connect } from 'react-redux';
import apiV2 from '../../utils/apiV2';
import searchicon from '../../assets/images/Managebooks/searchicon.svg';
import Polygon from '../../assets/images/Managebooks/Polygon.svg';
import visibility from '../../assets/images/Managebooks/visibility.svg';
import ManageBookActive from "../../assets/images/navbar_icons/managebookActive.svg";
import LottieAnimation from '../../components/Lottie/lottieAnimation';
import Moment from 'react-moment';
import { Modal } from 'react-bootstrap';
import crossbtn from '../../assets/images/CongratulationModal/crossBtn.svg';

var cx = require('classnames');

class PaperBack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paperbacks: [],
            isLoading: false,
            errors: {},
            search: '',
            sortByName: false,
            sortByAuthorName: false,
            sortByDate: false,
            sortByStatus: false,
            deleteModal: false,
            deleteId: null,
        };
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.fetchPaperbacks();
    }

    fetchPaperbacks = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await apiV2.get('/api/publisher/paperback');
            console.log('API Response:', response.data);
            
            // API response structure: { status: true, content: [...] }
            if (response.data && response.data.status && response.data.content) {
                const paperbacks = Array.isArray(response.data.content) ? response.data.content : [];
                console.log('Paperbacks from content:', paperbacks);
                console.log('First paperback ID:', paperbacks[0]?.id);
                this.setState({
                    paperbacks: paperbacks,
                    isLoading: false
                });
            } else if (response.data && response.data.data) {
                // Fallback for different response structure
                const paperbacks = Array.isArray(response.data.data) ? response.data.data : [];
                console.log('Paperbacks from data:', paperbacks);
                console.log('First paperback ID:', paperbacks[0]?.id);
                this.setState({
                    paperbacks: paperbacks,
                    isLoading: false
                });
            } else {
                this.setState({
                    paperbacks: [],
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error fetching paperbacks:', error);
            this.setState({
                errors: error.response?.data || { msg: 'Something went wrong' },
                isLoading: false,
                paperbacks: []
            });
        }
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value }, () => {
            this.onClickSearch();
        });
    }

    onClickSearch = () => {
        const { search, paperbacks } = this.state;
        if (!search.trim()) {
            this.fetchPaperbacks();
            return;
        }
        
        const filtered = paperbacks.filter(book => 
            book.Name?.toLowerCase().includes(search.toLowerCase()) ||
            book.Author_Name?.toLowerCase().includes(search.toLowerCase()) ||
            book.ISBN_Num?.toLowerCase().includes(search.toLowerCase())
        );
        this.setState({ paperbacks: filtered });
    }

    onPressSortByName = (colName, sort) => {
        const { paperbacks } = this.state;
        const sorted = [...paperbacks].sort((a, b) => {
            let aVal = a[colName] || '';
            let bVal = b[colName] || '';
            
            if (colName === 'createdAt') {
                aVal = new Date(aVal);
                bVal = new Date(bVal);
            } else {
                aVal = String(aVal).toLowerCase();
                bVal = String(bVal).toLowerCase();
            }
            
            if (sort === 'ASC') {
                return aVal > bVal ? 1 : -1;
            } else {
                return aVal < bVal ? 1 : -1;
            }
        });

        if (colName === "Author_Name") {
            this.setState({
                paperbacks: sorted,
                sortByAuthorName: !this.state.sortByAuthorName
            });
        } else if (colName === "createdAt") {
            this.setState({
                paperbacks: sorted,
                sortByDate: !this.state.sortByDate
            });
        } else if (colName === "Name") {
            this.setState({
                paperbacks: sorted,
                sortByName: !this.state.sortByName
            });
        } else if (colName === "Status") {
            this.setState({
                paperbacks: sorted,
                sortByStatus: !this.state.sortByStatus
            });
        }
    }

    onClickView = (paperback) => {
        // Redirect to AddNewPaperBack page with book data (same as ManageBook flow)
        this.props.history.push('/addnewpaperback', { book: paperback });
    }

    onClickDelete = (id) => {
        console.log('onClickDelete called with ID:', id);
        console.log('ID type:', typeof id);
        console.log('ID value:', id);
        
        // Check if id exists and is not empty string
        if (id && id !== '' && id !== null && id !== undefined) {
            this.setState({ deleteModal: true, deleteId: id });
        } else {
            console.error('Cannot delete: ID is missing or empty. ID value:', id);
            alert('Cannot delete: Book ID is missing. Please refresh the page and try again.');
        }
    }

    handleDelete = async () => {
        const { deleteId } = this.state;
        if (!deleteId) return;

        this.setState({ isLoading: true });
        try {
            const response = await apiV2.delete('/api/publisher/paperback', {
                data: { id: deleteId }
            });
            console.log('Delete Response:', response);
            console.log('Delete Response Data:', response.data);
            console.log('Delete Response Status:', response.status);
            
            // Check for success (200 status or response data)
            if (response.status === 200 || response.data) {
                this.setState({ 
                    deleteModal: false, 
                    deleteId: null,
                    isLoading: false 
                });
                this.fetchPaperbacks(); // Refresh list
            } else {
                this.setState({ 
                    deleteModal: false, 
                    deleteId: null,
                    isLoading: false,
                    errors: { msg: 'Failed to delete paperback' }
                });
            }
        } catch (error) {
            console.error('Error deleting paperback:', error);
            console.error('Error response:', error.response);
            this.setState({ 
                deleteModal: false, 
                deleteId: null,
                isLoading: false,
                errors: error.response?.data || { msg: 'Failed to delete paperback. Please try again.' }
            });
        }
    }



    renderTableRows = () => {
        const { paperbacks } = this.state;
        
        console.log('renderTableRows - paperbacks:', paperbacks);
        console.log('renderTableRows - paperbacks length:', paperbacks?.length);

        if (!paperbacks || paperbacks.length < 1) {
            console.log('No paperbacks to render');
            return (
                <tr>
                    <td className="text-center" colSpan="8">
                        <b>No Data To Display</b>
                    </td>
                </tr>
            );
        }

        console.log('Rendering', paperbacks.length, 'paperbacks');
        console.log('Sample paperback item:', paperbacks[0]);
        return paperbacks.map((item, i) => {
            // Log each item's id field for debugging
            if (i === 0) {
                console.log('Item ID fields:', {
                    id: item.id,
                    ID: item.ID,
                    _id: item._id,
                    fullItem: item
                });
            }
            return (
            <tr key={item.id || item.ID || i}>
                <td>
                    <img 
                        src={item.Image || 'https://via.placeholder.com/50'} 
                        width="50px" 
                        height="50px"
                        alt="book cover"
                        style={{ objectFit: 'cover' }}
                    ></img>
                </td>
                <td>{item.Name || 'N/A'}</td>
                <td>{item.Author_Name || 'N/A'}</td>
                <td>
                    {item.createdAt ? (
                        <Moment format="DD-MM-YY HH:MM">{item.createdAt}</Moment>
                    ) : (
                        'N/A'
                    )}
                </td>
                <td>
                    <div class={item.Status == 'Published' ? "table-badge-publish" : item.Status == 'On Review' ? "table-badge-review" : item.Status == "UnPublished" ? 'table-badge-unpublish' : "table-badge-blocked"}>
                        <label className="badge-label">
                            {item.Status || 'On Review'}
                        </label>
                    </div>
                </td>
                <td>{item.Category_ID || 'N/A'}</td>
                <td>
                    <img 
                        className="pointerr" 
                        src={visibility} 
                        onClick={() => this.onClickView(item)}
                        alt="view"
                        style={{ cursor: 'pointer' }}
                    ></img>
                </td>
                <td>
                    <button 
                        className="btn btn-sm btn-danger"
                        onClick={() => {
                            const deleteId = item.id || item.ID || item._id;
                            console.log('Delete button clicked - ID:', deleteId, 'Full item:', item);
                            this.onClickDelete(deleteId);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        Delete
                    </button>
                </td>
            </tr>
            );
        });
    }

    render() {
        const { isLoading, search, sortByName, sortByAuthorName, sortByDate, sortByStatus, deleteModal } = this.state;

        if (isLoading && this.state.paperbacks.length === 0) {
            return <LottieAnimation />;
        }

        return (
            <div>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 managebookContainer">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-3 AllbookContainer">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                        <p className="Allbook-heading mb-0">All Paperbacks</p>
                                        <p className="allbooktext mb-0">All your paperbacks that are Published and under review</p>
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div className="row">
                                            <div className="col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4"></div>
                                            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 p-0 pr-4 text-right">
                                                <img className="searchicon" src={searchicon} alt="search"></img>
                                                <input 
                                                    className="search_input" 
                                                    placeholder="search here" 
                                                    name="search" 
                                                    value={search}
                                                    onChange={this.onChange}
                                                ></input>
                                                <button className="allbook-search-btn">search</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-3 AllbookContainer">
                                <div className="table-responsive mt-4 checkout_container">
                                    <table className="table table-hover thead-primary">
                                        <thead>
                                            <tr>
                                                <th scope="col table_header poppins_medium">Book Title</th>
                                                {sortByName ? (
                                                    <th scope="col table_header poppins_medium">
                                                        Book Name <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('Name', 'ASC')} alt="sort"></img>
                                                    </th>
                                                ) : (
                                                    <th scope="col table_header poppins_medium">
                                                        Book Name <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('Name', 'DESC')} alt="sort"></img>
                                                    </th>
                                                )}
                                                {sortByAuthorName ? (
                                                    <th scope="col table_header poppins_medium">
                                                        Author Name <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('Author_Name', 'ASC')} alt="sort"></img>
                                                    </th>
                                                ) : (
                                                    <th scope="col table_header poppins_medium">
                                                        Author Name <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('Author_Name', 'DESC')} alt="sort"></img>
                                                    </th>
                                                )}
                                                {sortByDate ? (
                                                    <th scope="col table_header poppins_medium">
                                                        Date & Time <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('createdAt', 'ASC')} alt="sort"></img>
                                                    </th>
                                                ) : (
                                                    <th scope="col table_header poppins_medium">
                                                        Date & Time <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('createdAt', 'DESC')} alt="sort"></img>
                                                    </th>
                                                )}
                                                {sortByStatus ? (
                                                    <th scope="col table_header poppins_medium">
                                                        Status <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('Status', 'ASC')} alt="sort"></img>
                                                    </th>
                                                ) : (
                                                    <th scope="col table_header poppins_medium">
                                                        Status <img className="dropicon" src={Polygon} onClick={() => this.onPressSortByName('Status', 'DESC')} alt="sort"></img>
                                                    </th>
                                                )}
                                                <th scope="col table_header poppins_medium">Category</th>
                                                <th scope="col table_header poppins_medium">View</th>
                                                <th scope="col table_header poppins_medium">Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.paperbacks && this.state.paperbacks.length > 0 ? (
                                                this.renderTableRows()
                                            ) : (
                                                <tr>
                                                    <td className="text-center" colSpan="8">
                                                        <b>No Data To Display</b>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete Confirmation Modal */}
                <Modal
                    show={deleteModal}
                    onHide={() => this.setState({ deleteModal: false, deleteId: null, errors: {} })}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Paperback</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.errors.msg && (
                            <div className="alert alert-danger" role="alert">
                                {this.state.errors.msg}
                            </div>
                        )}
                        <p>Are you sure you want to delete this paperback? This action cannot be undone.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button 
                            className="btn btn-secondary" 
                            onClick={() => this.setState({ deleteModal: false, deleteId: null, errors: {} })}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button 
                            className="btn btn-danger" 
                            onClick={this.handleDelete}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Deleting...' : 'Delete'}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps)(PaperBack);
